import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Box } from "@mui/material";

const DataTableGeneric = ({ columns, rows }) => {
  // Estado para alternar entre paginación y mostrar todos los datos
  const [showAll, setShowAll] = useState(false);

  const formattedColumns = columns.map((col) => {
    const baseColumn = {
      name: col.label,
      selector: (row) => row[col.id],
      sortable: true,
    };

    // Aplicar width si está definido en la columna
    if (col.width) {
      baseColumn.width = col.width;
    }

    // Renderizado especial para la columna de acciones
    if (col.id === "actions" && Array.isArray(rows[0]?.actions)) {
      baseColumn.cell = (row) =>
        row.actions.map((action, idx) => (
          <Button
            key={action.id || idx}
            variant="contained"
            size="small"
            onClick={action.onClick}
            sx={{
              marginRight: "4px",
              whiteSpace: "nowrap",
              textTransform: "none",
              fontSize: "0.75rem",
              padding: "4px 8px",
            }}
            disabled={action.disabled}
          >
            {action.buttonText}
          </Button>
        ));
    } else {
      baseColumn.cell = (row) =>
        col.id === "actions" && Array.isArray(row.actions)
          ? row.actions.map((action, idx) => (
              <Button
                key={action.id || idx}
                variant="contained"
                size="small"
                onClick={action.onClick}
                sx={{
                  marginRight: "4px",
                  whiteSpace: "nowrap",
                  textTransform: "none",
                  fontSize: "0.75rem",
                  padding: "4px 8px",
                }}
                disabled={action.disabled}
              >
                {action.buttonText}
              </Button>
            ))
          : row[col.id];
    }

    return baseColumn;
  });

  return (
    <div>
      <DataTable
        columns={formattedColumns}
        data={rows}
        pagination={!showAll}
        paginationComponentOptions={{
          rowsPerPageText: "Filas por página",
          rangeSeparatorText: "de",
          noRowsPerPage: false,
        }}
        highlightOnHover
        noDataComponent={<div>No hay registros</div>}
        responsive
        striped
      />
      {/* Botón para alternar entre Mostrar todos los registros y paginación */}
      {rows.length > 0 && (
        <Button onClick={() => setShowAll((prev) => !prev)} variant="outlined" sx={{ mt: 3 }}>
          {showAll ? "Paginación" : "Mostrar todo"}
        </Button>
      )}
    </div>
  );
};

export default DataTableGeneric;
